module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007_Theelusive#fm-1"
    }
  }, [_vm._v("The Elusive Search")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Mask1#ch-1"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 1:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Shame")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Mask1#ch-1"
    }
  }, [_c('em', [_vm._v("Finding Worth as an Image Bearer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Mask2#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 2:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Good Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Mask2#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Acceptance as a Redeemed Sinner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Mask3#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 3:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Independence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Mask3#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Freedom as a Servant")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Mask4#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 4:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Individuality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Mask4#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Rest as a Sheep of the Good Shepherd")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Mask5#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 5:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Desires")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Mask5#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Satisfaction as a Saint")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Mask6#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 6:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Marriage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Mask6#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Wholeness as the Bride of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Mask7#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 7:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Parenthood")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Mask7#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Belonging as an Adopted Son")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Mask8#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 8:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Ideologies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Mask8#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Humility as Jesus’s Friend")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Mask9#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 9:")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Career")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Mask9#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Purpose as a Gifted Member of God’s Family")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Mask10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("Mask 10:")]), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("Patriotism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Mask10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Finding Boldness as an Ambassador of Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Nowwhat#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now What?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Ack#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Appendix#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Our Biblical Identities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/021_endnotes#bm-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c55e195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0